import { render } from "./EditPassword.vue?vue&type=template&id=4a020776&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"

import "./EditPassword.vue?vue&type=style&index=0&id=4a020776&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a020776"]])

export default __exports__